import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Radio, { RadioGroup } from 'material-ui/Radio'
import { FormLabel, FormControl, FormControlLabel, /* FormHelperText */ } from 'material-ui/Form'
import SimpleCard from './SimpleCard'
// import Typography from 'material-ui/Typography'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
    textAlign: 'left',
  },
  option: {
    marginRight: 0,
    marginLeft: -30,
  },
})

const getOption = (options, key) => options.filter(op => op.key === key)[0];

class RadioButtonsGroup extends React.Component {
  constructor(props){
    super(props);
    if (this.props.selectedOption) {
      this.state = {
        selectedOption: this.props.selectedOption.key
      }; 
    }else{
      this.state = {
        selectedOption: 'default'
      }; 
    }
  }

  render () {
    const {classes} = this.props
    const option = this.state.selectedOption || 'default';
    const renderOptions = this.props.options.map((data, idx) => {
      if (data.key !== 'default') {
        return <FormControlLabel key={data.key} value={data.key} control={<Radio />} label={data.headline}  className={classes.option}/>
      }
      return '';
    })
    const currentOption = getOption(this.props.options, option);
    return (
      <div>
        <div className={classes.root}>
          <FormControl component="fieldset" required className={classes.formControl}>
            <FormLabel component="legend">Opciones de inscripción</FormLabel>
            <RadioGroup
              aria-label="registryOptions"
              name="registryOptions1"
              className={classes.group}
              value={this.state.selectedOption}
              onChange={this.handleChange}
            >
              {renderOptions}
            </RadioGroup>
          </FormControl>
        </div>
        <SimpleCard title="Opciones de inscripción"
                    headline={currentOption.headline}
                    content={currentOption.content}/>
      </div>
    )
  }

  handleChange = (event, selectedOption) => {
    const currentOption = getOption(this.props.options, selectedOption);
    this.setState({selectedOption})
    this.props.choiceHandler(currentOption)
  }
}

RadioButtonsGroup.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(RadioButtonsGroup)


// WEBPACK FOOTER //
// ./src/components/ChooseOptions.jsx